import colors from '../Colors';

/* @component */
export default {
  // Black Borders
  borderBlack1: `border: 1px solid ${colors.grayscale.black}`,
  borderBlack15: `border: 1.5px solid ${colors.grayscale.black}`,
  borderBlack2: `border: 2px solid ${colors.grayscale.black}`,

  // Blue Borders
  borderBlue1: `border: 1px solid ${colors.blue.primary}`,
  borderBlue1_5: `border: 1.5px solid ${colors.blue.primary}`,
  borderBlue2: `border: 2px solid ${colors.blue.primary}`,

  // Gray Borders
  borderGray0_1: `border: 1px solid ${colors.grayscale.gray0}`,
  borderGray0_1_5: `border: 1.5px solid ${colors.grayscale.gray0}`,
  borderGray0_2: `border: 2px solid ${colors.grayscale.gray0}`,

  borderGray1_1: `border: 1px solid ${colors.grayscale.gray1}`,
  borderGray1_1_5: `border: 1.5px solid ${colors.grayscale.gray1}`,
  borderGray1_2: `border: 2px solid ${colors.grayscale.gray1}`,

  borderGray2_1: `border: 1px solid ${colors.grayscale.gray2}`,
  borderGray2_1_5: `border: 1.5px solid ${colors.grayscale.gray2}`,
  borderGray2_2: `border: 2px solid ${colors.grayscale.gray2}`,

  // Red Borders
  borderRed1: `border: 1px solid ${colors.red.primary}`,
  borderRed1_5: `border: 1.5px solid ${colors.red.primary}`,
  borderRed2: `border: 2px solid ${colors.red.primary}`,

  // Transparent Borders
  borderTransparent1: `border: 1px solid transparent`,
  borderTransparent1_5: `border: 1.5px solid transparent`,
  borderTransparent2: `border: 2px solid transparent`,

  // White Borders
  borderWhite1: `border: 1px solid ${colors.grayscale.white}`,
  borderWhite1_5: `border: 1.5px solid ${colors.grayscale.white}`,
  borderWhite2: `border: 2px solid ${colors.grayscale.white}`,
  borderWhite8: `border: 8px solid ${colors.grayscale.white}`,

  // Yellow Borders
  borderYellow1: `border: 1px solid ${colors.yellow.primary}`,
  borderYellow1_5: `border: 1.5px solid ${colors.yellow.primary}`,
  borderYellow2: `border: 2px solid ${colors.yellow.primary}`,
};
